<template>
	<div class="sf-table">
		<table class="qms-table">
			<tbody>
				<tr>
					<!-- 제품ID No. -->
					<th>* {{ getMessage_('QWCC001936') }}</th>
					<td class="col-1">
						{{ selectedRow.pmcNo }}
					</td>
					<!-- 차수 -->
					<th>{{ getMessage_('QWCC001379') }}</th>
					<td class="col-1">
						{{ selectedRow.ipnNos }}
					</td>
					<!-- 고객사명 -->
					<th>{{ getMessage_('QWCC001937') }}</th>
					<td class="col-1">
						<el-input
							:value="selectedRow.custNm"
							:placeholder="popupSearchParams.pmcNo && popupSearchParams.ipnNos && getMessage_('QWCC001656')"
							@keyup.native.delete="() => onUserInPutKeyDown('cust')"
							readonly
						>
						</el-input>
						<span class="unit input-icon">
							<template v-if="!selectedRow.custCd">
								<i
									class="icon-sf-search search-icon"
									@click="onPqyCpnyPopup"
									v-show="popupSearchParams.pmcNo && popupSearchParams.ipnNos"
								></i>
							</template>
							<template v-else>
								<i class="icon-sf-circle-close search-icon mr-2 mt-1" @click="removeCustCd" style="font-size: 0.6em !important"></i>
							</template>
						</span>
					</td>
					<!-- MES 검사시작 -->
					<th>{{ getMessage_('QWCC001977') }}</th>
					<td>
						{{ selectedRow.ckuStrtDt }}
					</td>
					<!-- MES 종료일자 -->
					<th>{{ getMessage_('QWCC001978') }}</th>
					<td>
						{{ selectedRow.ckuEndDt }}
					</td>
					<!-- 성적서 출력 -->
					<th>{{ getMessage_('QWCC001381') }}</th>
					<td>
						<sf-select-group
							labelPosition="left"
							:inputValue="selectedRow.oputStCd"
							:options="oputStCdList"
							:onChange="val => setSelectedRow(val, 'oputStCd')"
							:placeholder="getMessage_('QWCC001381')"
							:disabled="!setPrintSts"
						/>
					</td>
				</tr>
				<tr>
					<!-- 검사원 -->
					<th>{{ getMessage_('QWCC000009') }}</th>
					<td>
						{{ getPprrNm }}
					</td>
					<!-- 검사일시 -->
					<th>{{ getMessage_('QWCC001983') }}</th>
					<td>
						{{ selectedRow.pprrDt }}
					</td>
					<!-- 검토자 -->
					<th>{{ getMessage_('QWCC001092') }}</th>
					<td class="col-1">
						<el-input
							:value="selectedRow.rvwrNm"
							@input="val => setDetailForm(val, 'rvwrId')"
							:placeholder="!setDisabled && getMessage_('QWCC001656')"
							@keyup.native.delete="() => onUserInPutKeyDown('rvwr')"
							readonly
						>
						</el-input>
						<span class="unit input-icon" v-if="!setDisabled">
							<i class="icon-sf-search search-icon" @click="() => onUserPopup('rvwr')"></i>
						</span>
					</td>
					<!-- 검토일 -->
					<th>{{ getMessage_('QWCC001384') }}</th>
					<td>
						<!-- <el-date-picker
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							:value="selectedRow.rvwDd?.replaceAll('-', '')"
							readonly
							@input="val => setDetailForm(val, 'rvwDd')"
						/> -->
						{{ selectedRow.rvwDd }}
					</td>
					<!-- 승인자 -->
					<th>{{ getMessage_('QWCC000011') }}</th>
					<td class="col-1">
						<el-input
							:value="selectedRow.cserNm"
							@input="val => setDetailForm(val, 'cserId')"
							:placeholder="!setDisabled && getMessage_('QWCC001656')"
							@keyup.native.delete="() => onUserInPutKeyDown('cser')"
							readonly
						>
						</el-input>
						<span class="unit input-icon" v-if="!setDisabled">
							<i class="icon-sf-search search-icon" @click="() => onUserPopup('cser')"></i>
						</span>
					</td>
					<!-- 승인일 -->
					<th>{{ getMessage_('QWCC000012') }}</th>
					<td>
						{{ selectedRow.csetDd }}
					</td>
				</tr>
				<tr>
					<!-- 검사항목수 -->
					<th>{{ getMessage_('QWCC001374') }}</th>
					<td>
						{{ resultList.length }}
					</td>
					<!-- 불합격 항목수 -->
					<th>{{ getMessage_('QWCC001386') }}</th>
					<td>
						{{ getNgSum }}
					</td>
					<!-- 종합판정 -->
					<th>{{ getMessage_('QWCC000008') }}</th>
					<td :class="!selectedRow.csetDd && !!(getNgSum > 0 && selectedRow.jgmtRsltCd == 'OK') && 'rsltNg'">
						<sf-select-group
							labelPosition="left"
							:inputValue="getJgmtRslt"
							:options="indvJgmtCdList"
							:onChange="val => setSelectedRow(val, 'jgmtRsltCd')"
							:placeholder="getMessage_('QWCC000008')"
							:disabled="!!setDisabled"
						></sf-select-group>
					</td>
					<!-- 불량내용 -->
					<th>{{ getMessage_('QWCC001387') }}</th>
					<td colspan="5">
						<el-input
							maxlength="65"
							:show-word-limit="true"
							:value="selectedRow.badSbc"
							@input="val => setSelectedRow(val, 'badSbc')"
							:readonly="!!setDisabled"
						/>
					</td>
				</tr>
				<tr>
					<!-- 공정품질 -->
					<th>{{ getMessage_('QWCC001938') }}</th>
					<td>
						<span :class="!this.selectedRow.csetDd && attentionList.includes('POW_QLTY') && 'warned'">
							{{ !selectedRow.powQltyCd ? '' : selectedRow.powQltyCd === 'OK' ? getMessage_('QWCC002000') : getMessage_('QWCC001964') }}
						</span>
						<!-- <sf-select-group
							labelPosition="left"
							:inputValue="selectedRow.powQltyCd"
							:options="indvJgmtCdList"
							:onChange="val => setSelectedRow(val, 'powQltyCd')"
							:placeholder="getMessage_('QWCC001938')"
							disabled
						/> -->
					</td>
					<!-- LOT누락 -->
					<th>{{ getMessage_('QWCC001939') }}</th>
					<td>
						<span :class="!selectedRow.csetDd && attentionList.includes('PART_BLO') && 'warned'">
							{{ !selectedRow.partBloCd ? '' : selectedRow.partBloCd === 'OK' ? getMessage_('QWCC002000') : getMessage_('QWCC001964') }}
						</span>
					</td>
					<!-- 입고검사 -->
					<th>{{ getMessage_('QWCC001979') }}</th>
					<td>
						<span :class="!selectedRow.csetDd && attentionList.includes('PART_SRG') && 'warned'">
							{{ !selectedRow.partSrgCd ? '' : selectedRow.partSrgCd === 'OK' ? getMessage_('QWCC002000') : getMessage_('QWCC001964') }}
						</span>
					</td>
					<!-- 외관 -->
					<th>{{ getMessage_('QWCC001941') }}</th>
					<td>
						<span :class="!selectedRow.csetDd && attentionList.includes('APEN') && 'warned'">
							{{ !selectedRow.apenCkuCd ? '' : selectedRow.apenCkuCd === 'OK' ? getMessage_('QWCC002000') : getMessage_('QWCC001964') }}
						</span>
					</td>
					<!-- 체결상태 -->
					<th>{{ getMessage_('QWCC001942') }}</th>
					<td>
						<span :class="!selectedRow.csetDd && attentionList.includes('CLFC_ST') && 'warned'">
							{{ !selectedRow.clfcStCd ? '' : selectedRow.clfcStCd === 'OK' ? getMessage_('QWCC002000') : getMessage_('QWCC001964') }}
						</span>
					</td>
					<!-- 배선 / 배관 -->
					<th>{{ getMessage_('QWCC001943') + ' / ' + getMessage_('QWCC001944') }}</th>
					<td>
						<span :class="!selectedRow.csetDd && attentionList.includes('CDCN_ST') && 'warned'">
							{{ !selectedRow.cdcnStCd ? '' : selectedRow.cdcnStCd === 'OK' ? getMessage_('QWCC002000') : getMessage_('QWCC001964') }}
						</span>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- 팝업추가 영역 -->
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
		<user-popup-view ref="userPopupView" @SendData="sendData" :scrId="scrId" />
	</div>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/fcku/FwdCkuStts/store/helpers';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { UserPopupView, CompPopup },
	created() {
		this.setSelectedRow_({ key: 'pmcNo', value: this.popupSearchParams.pmcNo || '' });
		this.setSelectedRow_({ key: 'custCd', value: this.popupSearchParams.custCd || '' });
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		getPprrNm() {
			if (this.selectedRow.pmcNo) {
				if (Number(this.selectedRow.ipnNos) <= 1) return this.user.userName;
				else return this.selectedRow.pprrNm || '';
			} else return '';
		},
		getNgSum() {
			if (this.selectedRow.pmcNo) {
				return this.resultList.filter(el => el.prvsRsltCd === 'NG').length;
			} else return '';
		},
		getJgmtRslt() {
			if (this.selectedRow.pmcNo) {
				const value = this.selectedRow.jgmtRsltCd ? this.selectedRow.jgmtRsltCd : this.getNgSum > 0 ? 'NG' : 'OK';
				this.setSelectedRow_({ key: 'jgmtRsltCd', value });
				return value;
			} else return '';
		},
		setDisabled() {
			if (!this.selectedRow.pmcNo || !this.selectedRow.ipnNos) return true;
			return !!this.selectedRow.csetDd;
		},
		setPrintSts() {
			// 작성이 완료된 상태이며, 미출력상태가 아닐 경우, 검토자나 승인자에 해당될 경우 성적서 출력 값을 변경 할 수 있다.
			const sessionUserId = window.atob(this.user.userId);
			return (
				this.selectedRow.csetDd &&
				this.selectedRow.oputStCd !== '10' &&
				(sessionUserId === this.selectedRow.rvwrId || sessionUserId === this.selectedRow.cserId)
			);
		},
		showCustBtn() {
			if (this.setDisabled) return false;
			return this.popupSearchParams.custYn === 'Y';
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSelectedRow(value, key) {
			if (key === 'jgmtRsltCd') {
				if (value === 'OK' && !!(this.getNgSum > 0)) {
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'error',
						title: this.getMessage_('QWCC001997'),
						message: this.getMessage_('QWCC002004'),
						buttons: [{ title: 'Ok', clickFn: () => this.setSelectedRow_({ key, value }) }],
						closeFn: () => {
							this.setSelectedRow_({ key, value: this.selectedRow.oldJgmtRsltCd });
						}
					});
					return;
				}
			}
			if (key === 'ipnDd' && this.$moment(value).isAfter(this.$moment())) {
				this.$sf_toast({
					type: 'error',
					message: this.$sf_formatString(this.getMessage_('QWCC001400'), [this.getMessage_('QWCC000070'), this.getMessage_('QWCC001383')])
				});
				value = this.$moment().format('YYYYMMDD');
			}
			if (key === 'oputStCd' && value !== '10') {
				return;
			}
			this.setSelectedRow_({ key, value });
		},
		commInput({ key, value }) {
			this.setSelectedRow_({ key, value });
		},
		async removeCustCd() {
			this.setPopupSearchParam_({ key: 'custCd', value: '' });
			this.setPopupSearchParam_({ key: 'custNm', value: '' });
			this.setSelectedRow_({ key: 'custCd', value: '' });
			this.$sf_toggleLoading(true);
			await this.getPopupList_(this.hasChanged_);
			this.$sf_toggleLoading(false);
			this.setSelectedRow_({ key: 'custNm', value: '' });
		},
		onUserPopup(userGbn) {
			this.$refs.userPopupView.open({ userGbn, userName: this.selectedRow[userGbn + 'Nm'] });
		},
		sendData(userData, userGbn) {
			this.setSelectedRow(userData.userId, userGbn + 'Id');
			this.setSelectedRow(userData.userName, userGbn + 'Nm');
		},
		onUserInPutKeyDown(userGbn) {
			this.setSelectedRow('', userGbn + 'Id');
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			if (!this.selectedRow.csetDd) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001998') }); //작성이 끝난 후에 고객사 선택이 가능합니다. 작성을 완료해주세요.
				return;
			}
			const params = {
				cpnyScn: this.popupSearchParams.cpnyScn,
				cpnyCd: this.popupSearchParams.custCd
			};
			this.$refs.compPopup.open(params);
		},
		async qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setPopupSearchParam_({ key: 'custCd', value: cpnyCd });
			this.setPopupSearchParam_({ key: 'custNm', value: cpnyNm });
			this.setSelectedRow_({ key: 'custCd', value: cpnyCd });
			this.$sf_toggleLoading(true);
			await this.getPopupList_(this.hasChanged_);
			this.setSelectedRow_({ key: 'custNm', value: cpnyNm }); // 업체 변경시 서버에서 고객사명을 못가져옴 (아직 저장된 데이터가 아니기 때문)
			this.setSelectedRow_({ key: 'oputStCd', value: '10' }); //10 : 미출력
			this.$sf_toggleLoading(false);
		}
	}
};
</script>
<style lang="scss">
.search-icon {
	top: 4px !important;
	right: 3px !important;
	font-size: 20px;
}
</style>
